import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'statusClass'
})
export class StatusClassPipe implements PipeTransform {
    constructor() {
    }

    transform(status: string): any {
        const classes = {
            '': 'text-default',
            'confirmed': 'text-success',
            'blocked': 'text-danger',
            'pending': 'text-warning',
            'canceled': 'text-danger'
        };
        return classes[status];
    }
}
